// extracted by mini-css-extract-plugin
export default {"wrapper":"NotificationBannerV2-module__wrapper--b6a15","close":"NotificationBannerV2-module__close--b4ac8","markdown":"NotificationBannerV2-module__markdown--a1e17"};